import apiClient from '@/services/api_client';

export type SlideEvalIssue = {
    criterion: string;
    description: string;
    severity: 'minor' | 'major' | 'blocking';
    likely_renderer_artifact: boolean;
};

export type SlideEvalSlide = {
    index: number;
    score: number | null;
    criteria?: Record<string, number | null>;
    issues?: SlideEvalIssue[];
    error?: string;
};

export type SlideEvalItem = {
    eval_id: string;
    kind: string | null;
    tenant_id: string | null;
    tenant_name: string | null;
    document_id: string | null;
    document_name: string | null;
    created_at: string | null;
    duration_s: number | null;
    status: 'SUCCESS' | 'ERROR' | null;
    error: string | null;
    model: string | null;
    reference_renderer: string | null;
    candidate_renderer: string | null;
    deck_score: number | null;
    source_slide_count: number | null;
    rendered_slide_count: number | null;
    evaluated_count: number | null;
    slides: SlideEvalSlide[];
};

// Cross-tenant, Elqano-admin only. `tenantId` is NOT a filter — it's the caller's
// own tenant, required by the Elqano-admin auth gate.
export async function listSlideEvals(
    tenantId: string,
    limit = 50,
    offset = 0
): Promise<SlideEvalItem[]> {
    const url =
        `/slide_evals?tenant_id=${encodeURIComponent(tenantId)}` +
        `&limit=${limit}&offset=${offset}`;
    const response = await apiClient.get(url);
    return await response.json();
}

// The image routes are bearer-authenticated, so an <img src> pointing at them would
// 401: fetch the bytes and hand the template an object URL instead.
export async function fetchSlideEvalImage(
    tenantId: string,
    item: SlideEvalItem,
    side: 'source' | 'rendered',
    index: number
): Promise<string> {
    const url =
        `/slide_evals/${item.tenant_id}/${item.eval_id}/images/${side}/${index}` +
        `?tenant_id=${encodeURIComponent(tenantId)}`;
    const response = await apiClient.get(url);
    return URL.createObjectURL(await response.blob());
}
